import { useState, useEffect, Fragment, Component } from 'react';
import { Card, InfoCard, ChipTable } from '../components/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faMapSigns, faPlus, faUser,  faPhone, faMailBulk, faAddressCard, faBuilding, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import Modal    from '../components/Modal';
import Spinner    from '../components/Spinner';
import { InputText, TextArea, Radio } from '../components/Input';
import { Toast as ToastComponent } from '../components/Toast';
import toast, { Toaster } from 'react-hot-toast';
import { SmallNavbar } from '../components/Navbar';
import { NavLink }   from 'react-router-dom';
import FullLoader from '../components/FullLoader';
import { getAllPelanggan, createPelanggan, deleteUser, uploadProfile } from '../api/Pelanggan';
import { onlyNumber } from '../api/Value';
import { Switch } from '@headlessui/react';
import { checkType } from '../api/Value';
import Form  from './Pelanggan/Form'
import FormDetail from './Pelanggan/FormDetail'
import Table from './Pelanggan/Table';
import { ActiveDropdown } from '../config/Config';

/*     
toast.custom((t) => {
    return <ToastComponent param={t} message="Pelanggan Gagal das" bg="amber"/>
})
*/
export default class Home extends Component{
    constructor(props){
        super(props);
        this.state = {
            myModalForm: false,
            myDeleteForm: false,
            messageToast: [{ status: false, message: "Gagal menghapus Pelanggan" }, { status: false, message: "Gagal menghapus Pelanggan" }],
            loading: false,
            data: [],
            detailForm: {},
            detailModal: false,
            idDeletePelanggan: 0
        }
    }
    componentDidMount = () => {
        this.getAll()
        const act = document.getElementById("User_nav");
        if (act) {
            act.classList.add("border-b-4")
            act.classList.add(ActiveDropdown())
        }

    }
  componentWillUnmount = () => {
         const act = document.getElementById("User_nav");
        if (act) {
             act.classList.remove("border-b-4")
            act.classList.remove(ActiveDropdown())
        }
    }
    closeModalForm = (isUpdate=false) => {
        //console.log(isUpdate)
        if (isUpdate) {
           this.getAll();
           
        }
        this.setState({
            myModalForm: false,
            detailForm: {},
        }, () => {
         
        })
    }
    openModalForm = () => {
        this.setState({
            myModalForm: true
        })
    }
    closeDeleteForm = () => {
        this.setState({
            myDeleteForm: false
        })
    }
    openDeleteForm = (idUser) => {
         this.setState({
            myDeleteForm: true,
            idDeletePelanggan: idUser
        })
    }
    openDetailPelanggan = (index) => {
        this.setState({
            detailForm: this.state.data[index],
            detailModal: true
        })
    }
    closeModalDetail = () => {
        this.setState({
            detailModal: false,
            detailForm: {}
        })
    }
    // get all pelanggan
    getAll = () => {
        const self = this;
        getAllPelanggan().then((result) => {
            if(result.status == 200) {
                const data = result.data.map((x, index) => {
                            const user_info  = JSON.parse(x.user_info)
                            for(let u in user_info) {
                                x[u] = user_info[u]
                            }
                            x.index =index
                            return x
                        })
                self.setState({
                    data: data
                })
            }else{
            //    console.log(result)
                toast.custom((t) => {
                    return <ToastComponent param={t} message="Pelanggan Gagal di tambah" bg="red"/>
                })
            }
        })
    }
  
    // delete pelanggan
    deletePelanggan = async () => {
        const self=  this;
        deleteUser({ id_user: this.state.idDeletePelanggan }).then((res) => {
        //    console.log(res);   
            self.closeDeleteForm();
            self.getAll();
             toast.custom((t) => {
                return <ToastComponent param={t} message={res.data.data.rows_affected + " pelanggan dihapus "} bg="orange"/>
            }) 
        })
    }

    editForm = (index) => {
         this.setState({
            detailForm: this.state.data[index],
        }, () => {
            this.openModalForm();
        })
    }
    render(){
        // get object class
        const { closeDeleteForm, openModalForm, closeModalForm, openDeleteForm, openDetailPelanggan, closeModalDetail, deletePelanggan, editForm } = this;
        // get value state
        const { myModalForm, myDeleteForm, messageToast, loading, data, submitLoader, detailForm, detailModal } = this.state;
        // is loading full screen ? 
        if(loading){
            return <FullLoader/>
        }else{
            // default render
            return (
                 <div className=" p-5 animate-fadein">
                        <Toaster position="bottom-right"/>
                        <SmallNavbar left={
                        <Fragment>
                            <FontAwesomeIcon icon={faUser}  className="mt-1" />
                            <div className="flex-initial ml-2 " >
                                Pelanggan            
                            </div>
                        </Fragment>
                        } 
                            right = {
                                <button onClick={ openModalForm } className="bg-white h-10 rounded-full ml-2 p-1 text-blue-700 pl-4 pr-4 shadow-md hover:bg-gray-100 active:bg-gray-200 active:shadow-none ">
                                    <FontAwesomeIcon icon={faPlus} /> Tambah
                                </button>
                            }
                        />
                        <div className="bg-white rounded-md p-5">
                            <Table editForm={editForm} openDeleteForm={openDeleteForm} openDetailPelanggan={openDetailPelanggan} openModalForm = { openModalForm } Data_pelanggan = { data }/>            
                        </div>    
                        <Modal
                            Title = "Form Pelanggan"
                            Body  = {<Form closeModalForm={closeModalForm} detailForm={detailForm} />}
                            closeModal = {closeModalForm}
                            isOpen = {myModalForm}
                            Container = "max-w-4xl bg-white"
                        />

                        <Modal
                            Title = "Detail Pelanggan"
                            Body  = {<FormDetail 
                                        closeModalForm={ closeModalDetail } 
                                        myForm={detailForm} 
                                        />}
                            Footer = {""}
                            closeModal = {closeModalDetail}
                            isOpen = {detailModal}
                            Container = "max-w-4xl bg-white"
                        />

                        <Modal
                            Title = {<span className="text-white">Hapus Pelanggan</span>}
                            Body  = {<div className="text-white mt-5">Apakah Anda Yakin?</div>}
                            Footer = {<ModalDeleteFooter closeModal = {closeDeleteForm} onSubmit={deletePelanggan}/>}
                            closeModal = {closeDeleteForm}
                            isOpen = {myDeleteForm}
                            Container = "max-w-md bg-red-600"
                        />
                    </div>
            )
        }
    }
}


const ModalDeleteFooter = ({ closeModal, onSubmit }) => {
    const [ loader, setLoader ] = useState(false)

    const submit = () => {
        onSubmit();
        setLoader(true)
    }
    return(
        <div className="text-right flex justify-end">
            
            
            {
                (!loader) ?
                    <div>
                        <button className="font-bold bg-gray-300 p-2 shadow-md hover:bg-gray-400 active:bg-gray-500 active:shadow-none rounded-md w-32  text-gray-800" onClick={closeModal}>Batal</button>
                        <button onClick={submit} className=" font-bold bg-red-700 ml-2 p-2 shadow-md hover:bg-red-800 active:bg-red-900 active:shadow-none rounded-md w-32 text-white">
                                Yakin
                        </button>
                    </div>
                : 
                <button className="opacity-70 cursor-not-allowed flex font-bold bg-red-900 ml-2 p-2 rounded-md w-52 text-white">
                    <div className="w-1/4">
                        <Spinner 
                            color="rgb(255 255 255)"
                            width="30px"
                            height="30px"
                        />
                    </div>
                    
                    <div className="pt-1">
                        Mohon Tunggu
                    </div>
                </button>
            }
            

        </div>
    )
}